
import deviceResolution from '@scripts/mixins/device-resolution'
export default {
  name: 'SghTooltip',
  mixins: [deviceResolution],
  props: {
   visible: {
      type: Boolean,
      default: false,
    },
    tooltipBoundingElement: {
      type: HTMLElement,
      default: null,
    },
    tooltipId: {
      type: String,
      default: '',
    },

  },
  data() {
    return {
      isOverFlow: false,
      wrapperPosition: {
        left:0,
        top:0,
      },
    }
  },
  updated() {
    this.getTooltipOverFlow()
  },
  computed: {
    additionalOffset() {
      return this.isMobile ? 50 : 25
    },
  },
  methods: {
    getTooltipOverFlow(){
      if(!this.visible) {
        return
      }
      this.$refs.tooltipWrapper.style.left = `-${(this.$refs.tooltipWrapper?.offsetWidth / 2 )}px`
      const tooltipRect = this.$refs.tooltipWrapper?.getBoundingClientRect()
      const toolTipBoundingRect = this.tooltipBoundingElement?.getBoundingClientRect()
      const tooltipRightContentOverflow = Math.abs(toolTipBoundingRect?.right - tooltipRect?.right) || 0
      const isToolTipOutOnTheRight = tooltipRect?.right > toolTipBoundingRect?.right
      const isToolTipOutOnTheLeft = tooltipRect?.left < toolTipBoundingRect?.left
      if(isToolTipOutOnTheRight) {
        this.$refs.tooltipWrapper.style.left = `-${(Math.abs(this.$refs.tooltipWrapper?.offsetLeft || 0) ) + tooltipRightContentOverflow - this.$refs.tooltipArrow?.offsetWidth + this.additionalOffset || 0}px`
      }
      if(isToolTipOutOnTheLeft){
        this.$refs.tooltipWrapper.style.left = `-${this.$refs.tooltipArrow?.offsetWidth + this.additionalOffset || 0}px`
      }
    },
  },
}
